import { useState } from "react";
import FilterPanel from "../../components/FilterPanel/FilterPanel";
import CallDataContainer from "../../components/CallDataContainer/CallDataContainer";
import ChartCountChiamate from "../../components/UI/Chart/ChartCountChiamate";
import ChartDeviceChiamate from "../../components/UI/Chart/ChartDeviceChiamate";
import ChartDurataChiamate from "../../components/UI/Chart/ChartDurataChiamate";
import Notification from "../../components/UI/Notification/Notification";


const Dashboard = () => {

  const [date, setDate] = useState({ isCorrectRangeData: false });
  const [deviceFilter, setDeviceFilter] = useState();
  const [ dateResponseSummaryCallCardContainer] = useState();
  const [isFetching] = useState(false);
  const [refreshHandleDateToFilterDate, setRefreshHandleDateToFilterDate] = useState(false);

  const handleDateToFilterDate = (objRangeData, selectedDevice) => {
    let arrayDeviceToView = [];
    selectedDevice.map(device => arrayDeviceToView.push(device.idUtente));
    setDate(objRangeData);
    setRefreshHandleDateToFilterDate(!refreshHandleDateToFilterDate);
    setDeviceFilter(arrayDeviceToView);
  };

  return (
    <>
      <FilterPanel
        handleDateToFilterDate={handleDateToFilterDate}
        isFetching={isFetching}
      />
      {(date.isCorrectRangeData) && 
        <>
           <CallDataContainer 
                date={dateResponseSummaryCallCardContainer}
                isFetching={isFetching} 
                refresh={refreshHandleDateToFilterDate}
                dataPicker={date}
                deviceFilter={deviceFilter}
            /> 
           <ChartCountChiamate
            date={dateResponseSummaryCallCardContainer}
            isFetching={isFetching} 
            refresh={refreshHandleDateToFilterDate}
            dataPicker={date} 
            deviceFilter={deviceFilter}
          /> 
            <ChartDurataChiamate
              date={dateResponseSummaryCallCardContainer}
              isFetching={isFetching} 
              refresh={refreshHandleDateToFilterDate}
              dataPicker={date} 
              deviceFilter={deviceFilter}
          /> 
           <ChartDeviceChiamate
              date={dateResponseSummaryCallCardContainer}
              isFetching={isFetching} 
              refresh={refreshHandleDateToFilterDate}
              dataPicker={date} 
              deviceFilter={deviceFilter}
            /> 
        </>
      }
      <Notification />
    </>
  );
};

export default Dashboard;
